export default class Browser {

    static instance;

    constructor(){
        if(this.constructor.instance){
            return this.constructor.instance
        }
        this._name = document.querySelector("html").dataset.browserName
        this.constructor.instance = this
    }

    get name() {
        return this._name
    }

}